import React from "react";
import { getClassName } from "@sscs/utils";
import { CheckCircleOutlineIcon, HighlightOffIcon, InfoIcon, WarningOutlineIcon, } from "../../icons";
import LinearProgress from "../LinearProgress/LinearProgress";
import styles from "./callout.module.scss";
const ICON_BY_TYPE = {
    info: InfoIcon,
    success: CheckCircleOutlineIcon,
    warning: WarningOutlineIcon,
    error: HighlightOffIcon,
};
/**
 * A static in-page feedback banner sharing the Toast per-type colours. Three modes:
 * - block (default): title with body content below.
 * - inline (`variant="inline"`): feedback colour on the title alone, no border/tint/icon — an in-row status line.
 * - progress (`type="progress"`): a neutral banner (no icon/colour) whose title ends in the rounded
 *   `progress` percentage, bar beneath.
 */
const Callout = (props) => {
    const { title, className } = props;
    if (props.type === "progress") {
        const { progress, children } = props;
        return (React.createElement("div", { className: getClassName(styles.root, styles.progress, className) },
            React.createElement("div", { className: styles.title },
                title,
                React.createElement("span", { className: styles.percent },
                    Math.round(progress),
                    "%")),
            React.createElement(LinearProgress, { className: styles.bar, progress: progress }),
            children !== undefined && (React.createElement("div", { className: styles.body }, children))));
    }
    if (props.variant === "inline") {
        return (React.createElement("div", { className: getClassName(styles.text, styles[props.type], className) }, title));
    }
    const { children } = props;
    const Glyph = ICON_BY_TYPE[props.type];
    return (React.createElement("div", { className: getClassName(styles.root, styles[props.type], className) },
        React.createElement("div", { className: styles.title },
            React.createElement(Glyph, null),
            title),
        React.createElement("div", { className: styles.body }, children)));
};
export default Callout;
//# sourceMappingURL=Callout.js.map